import { Companion_instance1x4tv1dkhzfnv as Companion_instance } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionPipe.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Builder3lcn00uc5gcy3 as Builder } from '../../../../../apollo-kotlin-apollo-runtime/com/apollographql/apollo/ApolloClient.mjs';
import { ktorClient27akr7bvktwel as ktorClient } from '../../../../../apollo-kotlin-ktor-support-apollo-engine-ktor/com/apollographql/ktor/KtorExtensions.mjs';
import { DispatcherPipeCannon3aitdk4bdtfxf as DispatcherPipeCannon } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionCannon.mjs';
import {
  perform1i7pbw8i1t7pf as perform,
  SdkBoost3eue7fgosgz0d as SdkBoost,
} from './SdkBoost.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  perform74s8c3nqyra5 as perform_0,
  SdkCreateSecretCommandDispatcher1ii7hep4t7p2 as SdkCreateSecretCommandDispatcher,
} from './SdkCreateSecretCommandDispatcher.mjs';
import {
  perform2zftka3kdmnum as perform_1,
  SdkDeletePairAssignmentsCommandDispatcher3r89xhj6g83sl as SdkDeletePairAssignmentsCommandDispatcher,
} from './SdkDeletePairAssignmentsCommandDispatcher.mjs';
import {
  perform135q09rn5vx21 as perform_2,
  SdkDeletePartyCommandDispatcher27loij2ye5nr9 as SdkDeletePartyCommandDispatcher,
} from './SdkDeletePartyCommandDispatcher.mjs';
import {
  perform31r9rbre92msf as perform_3,
  SdkDeletePinCommandDispatcher31mrzwlipmcuz as SdkDeletePinCommandDispatcher,
} from './SdkDeletePinCommandDispatcher.mjs';
import {
  perform2147ekggl6d8e as perform_4,
  SdkDeletePlayerCommandDispatcher2rxhmptx7gljw as SdkDeletePlayerCommandDispatcher,
} from './SdkDeletePlayerCommandDispatcher.mjs';
import {
  perform10168d6to4ns1 as perform_5,
  SdkDeleteSecretCommandDispatcher1wzqb0vkuors as SdkDeleteSecretCommandDispatcher,
} from './SdkDeleteSecretCommandDispatcher.mjs';
import {
  perform2x1zq42u51aie as perform_6,
  SdkGrantDiscordAccessjjorbkvtrfx9 as SdkGrantDiscordAccess,
} from './SdkGrantDiscordAccess.mjs';
import {
  perform1ygbfmihaa1i1 as perform_7,
  SdkGrantSlackAccess15ga4e1z55nsr as SdkGrantSlackAccess,
} from './SdkGrantSlackAccess.mjs';
import {
  performs68l90ameoy1 as perform_8,
  SdkGraphQueryDispatcher2qog4v6gbj5of as SdkGraphQueryDispatcher,
} from './SdkGraphQueryDispatcher.mjs';
import {
  perform1ylxtqtddrktl as perform_9,
  SdkSavePairAssignmentsCommandDispatcher3ocpuomh8jp9i as SdkSavePairAssignmentsCommandDispatcher,
} from './SdkPairAssignmentDocumentSave.mjs';
import {
  perform1fdolsk5zjf2x as perform_10,
  SdkSavePartyCommandDispatcher1x5cidvmu3vb0 as SdkSavePartyCommandDispatcher,
} from './SdkSavePartyCommandDispatcher.mjs';
import {
  perform2kotbz9rs9elb as perform_11,
  SdkSavePinCommandDispatcher1w2xmq7bhdmfl as SdkSavePinCommandDispatcher,
} from './SdkSavePinCommandDispatcher.mjs';
import {
  perform272nir7h51f3q as perform_12,
  SdkSavePlayerCommandDispatcher2k2b5uhezxdlq as SdkSavePlayerCommandDispatcher,
} from './SdkSavePlayerCommandDispatcher.mjs';
import {
  performj8mglkenbmy3 as perform_13,
  SdkSaveSlackIntegrationCommandDispatcher1t7cxnysmjc4h as SdkSaveSlackIntegrationCommandDispatcher,
} from './SdkSaveSlackIntegrationCommandDispatcher.mjs';
import {
  perform32xwahz7kfsec as perform_14,
  SdkSpin3glo2r2cb0vqe as SdkSpin,
} from './SdkSpin.mjs';
import {
  execute3ka32mbtyv00e as execute,
  GqlTrait2wtoeyl3yfalb as GqlTrait,
} from './gql/GqlTrait.mjs';
import { Dispatchernurlbopdkn3a as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatcher2xvjdz9qh940 as Dispatcher_0 } from './gql/GqlQuery.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_7 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher_9 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_12 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { Dispatcher2txct93ff9b99 as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_14 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  apolloMutation1qfm4b9xbpwrf as apolloMutation,
  apolloQuery2zskz0jq3m0l7 as apolloQuery,
  KtorQueryPerformer3enpohylr2sy5 as KtorQueryPerformer,
} from './gql/KtorQueryPerformer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function couplingSdk(getIdTokenFunc, httpClient, pipe) {
  pipe = pipe === VOID ? Companion_instance : pipe;
  return new (DispatcherPipeCannon())(new (KtorCouplingSdkDispatcher())(getIdTokenFunc, httpClient, ktorClient((new (Builder())()).p63('/api/graphql'), httpClient).n37()), pipe);
}
var KtorCouplingSdkDispatcherClass;
function KtorCouplingSdkDispatcher() {
  if (KtorCouplingSdkDispatcherClass === VOID) {
    class $ {
      constructor(getIdTokenFunc, httpClient, apolloClient) {
        this.k6q_1 = getIdTokenFunc;
        this.l6q_1 = new (StandardPartyGQLPerformer())(this.k6q_1, httpClient, apolloClient);
      }
      m6q() {
        return this.l6q_1;
      }
    }
    protoOf($).j2h = perform;
    protoOf($).f2j = perform_0;
    protoOf($).b2i = perform_1;
    protoOf($).k2i = perform_2;
    protoOf($).t2i = perform_3;
    protoOf($).z2i = perform_4;
    protoOf($).i2j = perform_5;
    protoOf($).m2h = perform_6;
    protoOf($).p2h = perform_7;
    protoOf($).n6q = perform_8;
    protoOf($).h2i = perform_9;
    protoOf($).n2i = perform_10;
    protoOf($).w2i = perform_11;
    protoOf($).c2j = perform_12;
    protoOf($).q2i = perform_13;
    protoOf($).s2h = perform_14;
    protoOf($).o6q = execute;
    initMetadataForClass($, 'KtorCouplingSdkDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13(), Dispatcher_14(), SdkBoost(), GqlTrait(), SdkCreateSecretCommandDispatcher(), SdkDeletePairAssignmentsCommandDispatcher(), SdkDeletePartyCommandDispatcher(), SdkDeletePinCommandDispatcher(), SdkDeletePlayerCommandDispatcher(), SdkDeleteSecretCommandDispatcher(), SdkGrantDiscordAccess(), SdkGrantSlackAccess(), SdkGraphQueryDispatcher(), SdkSavePairAssignmentsCommandDispatcher(), SdkSavePartyCommandDispatcher(), SdkSavePinCommandDispatcher(), SdkSavePlayerCommandDispatcher(), SdkSaveSlackIntegrationCommandDispatcher(), SdkSpin()], [1]);
    KtorCouplingSdkDispatcherClass = $;
  }
  return KtorCouplingSdkDispatcherClass;
}
var StandardPartyGQLPerformerClass;
function StandardPartyGQLPerformer() {
  if (StandardPartyGQLPerformerClass === VOID) {
    class $ {
      constructor(getIdTokenFunc, httpClient, apolloClient) {
        this.p6q_1 = getIdTokenFunc;
        this.q6q_1 = apolloClient;
        this.r6q_1 = httpClient;
      }
      s6q() {
        return this.q6q_1;
      }
      t6q($completion) {
        return this.p6q_1($completion);
      }
    }
    protoOf($).u6q = apolloMutation;
    protoOf($).v6q = apolloQuery;
    initMetadataForClass($, 'StandardPartyGQLPerformer', VOID, VOID, [KtorQueryPerformer()], [0, 1]);
    StandardPartyGQLPerformerClass = $;
  }
  return StandardPartyGQLPerformerClass;
}
//region block: exports
export {
  couplingSdk as couplingSdk1kvwqabhypuft,
};
//endregion

//# sourceMappingURL=KtorSdk.mjs.map
